import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";

export const FloatingCTA = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname.startsWith("/admin") || pathname === "/contact" || !visible) return null;
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 200 }}
      className="fixed bottom-6 right-6 z-50"
    >
      <Link
        to="/services/board-and-train"
        data-testid="floating-start-today-cta"
        className="flex items-center gap-2 bg-brand text-white font-heading font-bold px-7 py-4 rounded-full shadow-[0_0_25px_rgba(220,38,38,0.55)] hover:bg-red-700 hover:shadow-[0_0_35px_rgba(220,38,38,0.75)] transition-[background-color,box-shadow] text-base"
      >
        Book Now! <ArrowRight size={18} />
      </Link>
    </motion.div>
  );
};
